export const countries_descriptions = {
  'Afghanistan': {
    'highlights': ['Kabul', 'Band-e-Amir'],
    'why_visit': 'Silk Road history',
    'best_time': 'Apr–Oct',
    'language': 'Pashto, Dari'
  },
  'Aland Islands': {
    'highlights': ['Mariehamn', 'Archipelago'],
    'why_visit': 'Peaceful island nature',
    'best_time': 'May–Aug',
    'language': 'Swedish'
  },
  'Albania': {
    'highlights': ['Tirana', 'Riviera'],
    'why_visit': 'Beaches and mountains',
    'best_time': 'May–Sep',
    'language': 'Albanian'
  },
  'Algeria': {
    'highlights': ['Algiers', 'Sahara'],
    'why_visit': 'Vast desert beauty',
    'best_time': 'Oct–Apr',
    'language': 'Arabic, Tamazight'
  },
  'American Samoa': {
    'highlights': ['Pago Pago', 'Rainforests'],
    'why_visit': 'Polynesian culture',
    'best_time': 'May–Sep',
    'language': 'English, Samoan'
  },
  'Andorra': {
    'highlights': ['Andorra la Vella', 'Pyrenees'],
    'why_visit': 'Skiing and shopping',
    'best_time': 'Dec–Mar',
    'language': 'Catalan'
  },
  'Angola': {
    'highlights': ['Luanda', 'Kalandula'],
    'why_visit': 'Waterfalls and wildlife',
    'best_time': 'Jun–Sep',
    'language': 'Portuguese'
  },
  'Anguilla': {
    'highlights': ['The Valley', 'Shoal Bay'],
    'why_visit': 'Pristine white beaches',
    'best_time': 'Dec–Apr',
    'language': 'English'
  },
  'Antarctica': {
    'highlights': ['Peninsula', 'Ross Sea'],
    'why_visit': 'Untouched icy wilderness',
    'best_time': 'Nov–Mar',
    'language': 'No official language (research stations)'
  },
  'Antigua and Barbuda': {
    'highlights': [`St John's`, 'Beaches'],
    'why_visit': '365 stunning beaches',
    'best_time': 'Dec–Apr',
    'language': 'English'
  },
  'Argentina': {
    'highlights': ['Buenos Aires', 'Patagonia'],
    'why_visit': 'Tango and glaciers',
    'best_time': 'Oct–Mar',
    'language': 'Spanish'
  },
  'Armenia': {
    'highlights': ['Yerevan', 'Sevan'],
    'why_visit': 'Monasteries and brandy',
    'best_time': 'May–Oct',
    'language': 'Armenian'
  },
  'Aruba': {
    'highlights': ['Oranjestad', 'Eagle Beach'],
    'why_visit': 'Sunny desert island',
    'best_time': 'Dec–Apr',
    'language': 'Dutch, Papiamento'
  },
  'Australia': {
    'highlights': ['Sydney', 'Reef'],
    'why_visit': 'Unique wildlife',
    'best_time': 'Sep–Nov',
    'language': 'English'
  },
  'Austria': {
    'highlights': ['Vienna', 'Alps'],
    'why_visit': 'Music and skiing',
    'best_time': 'Dec–Mar',
    'language': 'German'
  },
  'Azerbaijan': {
    'highlights': ['Baku', 'Gobustan'],
    'why_visit': 'Fire and oil rocks',
    'best_time': 'Apr–Jun',
    'language': 'Azerbaijani'
  },
  'Bahamas': {
    'highlights': ['Nassau', 'Exumas'],
    'why_visit': 'Swimming pigs',
    'best_time': 'Dec–Apr',
    'language': 'English'
  },
  'Bahrain': {
    'highlights': ['Manama', `Qal'at al-Bahrain`],
    'why_visit': 'Pearl diving history',
    'best_time': 'Nov–Mar',
    'language': 'Arabic'
  },
  'Bangladesh': {
    'highlights': ['Dhaka', 'Sundarbans'],
    'why_visit': 'Mangrove tigers',
    'best_time': 'Oct–Mar',
    'language': 'Bengali'
  },
  'Barbados': {
    'highlights': ['Bridgetown', 'Crane Beach'],
    'why_visit': 'Rum and coral reefs',
    'best_time': 'Dec–Apr',
    'language': 'English'
  },
  'Belarus': {
    'highlights': ['Minsk', 'Brest'],
    'why_visit': 'Soviet heritage',
    'best_time': 'May–Sep',
    'language': 'Belarusian, Russian'
  },
  'Belgium': {
    'highlights': ['Brussels', 'Bruges'],
    'why_visit': 'Chocolate and beer',
    'best_time': 'Apr–Oct',
    'language': 'Dutch, French, German'
  },
  'Belize': {
    'highlights': ['Belmopan', 'Blue Hole'],
    'why_visit': 'Mayan ruins and diving',
    'best_time': 'Nov–Apr',
    'language': 'English'
  },
  'Benin': {
    'highlights': ['Porto-Novo', 'Ouidah'],
    'why_visit': 'Voodoo history',
    'best_time': 'Nov–Feb',
    'language': 'French'
  },
  'Bermuda': {
    'highlights': ['Hamilton', 'Pink Sands'],
    'why_visit': 'Pastel architecture',
    'best_time': 'Apr–Oct',
    'language': 'English'
  },
  'Bhutan': {
    'highlights': ['Thimphu', 'Paro Taktsang'],
    'why_visit': 'Happiness and mountains',
    'best_time': 'Mar–May',
    'language': 'Dzongkha'
  },
  'Bolivia': {
    'highlights': ['La Paz', 'Salar de Uyuni'],
    'why_visit': 'Salt flats and altitude',
    'best_time': 'Apr–Oct',
    'language': 'Spanish, Quechua, Aymara, Guarani'
  },
  'Bonaire, Saint Eustatius and Saba ': {
    'highlights': ['Kralendijk', 'Diving'],
    'why_visit': 'Underwater paradise',
    'best_time': 'Dec–Apr',
    'language': 'Dutch, Papiamento, English'
  },
  'Bosnia and Herzegovina': {
    'highlights': ['Sarajevo', 'Mostar'],
    'why_visit': 'Ottoman bridges',
    'best_time': 'May–Sep',
    'language': 'Bosnian, Serbian, Croatian'
  },
  'Botswana': {
    'highlights': ['Gaborone', 'Okavango'],
    'why_visit': 'Safari and deltas',
    'best_time': 'May–Oct',
    'language': 'English, Setswana'
  },
  'Bouvet Island': {
    'highlights': ['Glaciers', 'Volcano'],
    'why_visit': 'Remote icy island',
    'best_time': 'Jan–Mar',
    'language': 'Norwegian (de facto)'
  },
  'Brazil': {
    'highlights': ['Rio', 'Amazon'],
    'why_visit': 'Samba and jungle',
    'best_time': 'Sep–Oct',
    'language': 'Portuguese'
  },
  'British Indian Ocean Territory': {
    'highlights': ['Diego Garcia', 'Lagoon'],
    'why_visit': 'Untouched atolls',
    'best_time': 'May–Nov',
    'language': 'English'
  },
  'British Virgin Islands': {
    'highlights': ['Road Town', 'The Baths'],
    'why_visit': 'Sailing and coves',
    'best_time': 'Dec–Apr',
    'language': 'English'
  },
  'Brunei': {
    'highlights': ['Bandar Seri Begawan', 'Omar Ali Saifuddien'],
    'why_visit': 'Oil wealth and mosques',
    'best_time': 'January–May',
    'language': 'Malay'
  },
  'Bulgaria': {
    'highlights': ['Sofia', 'Plovdiv'],
    'why_visit': 'Rose valleys',
    'best_time': 'May–Sep',
    'language': 'Bulgarian'
  },
  'Burkina Faso': {
    'highlights': ['Ouagadougou', 'Sindou'],
    'why_visit': 'Vibrant music',
    'best_time': 'Nov–Feb',
    'language': 'French'
  },
  'Burundi': {
    'highlights': ['Bujumbura', 'Tanganyika'],
    'why_visit': 'Lake and mountains',
    'best_time': 'Jun–Aug',
    'language': 'Kirundi, French, English'
  },
  'Cambodia': {
    'highlights': ['Siem Reap', 'Angkor'],
    'why_visit': 'Ancient temples',
    'best_time': 'Nov–Mar',
    'language': 'Khmer'
  },
  'Cameroon': {
    'highlights': ['Yaoundé', 'Douala'],
    'why_visit': 'African diversity',
    'best_time': 'Nov–Feb',
    'language': 'French, English'
  },
  'Canada': {
    'highlights': ['Banff', 'Niagara'],
    'why_visit': 'Maple and wilderness',
    'best_time': 'Jun–Sep',
    'language': 'English, French'
  },
  'Cape Verde': {
    'highlights': ['Praia', 'Mindelo'],
    'why_visit': 'Volcanic beaches',
    'best_time': 'January–Jun',
    'language': 'Portuguese'
  },
  'Cayman Islands': {
    'highlights': ['George Town', 'Stingray City'],
    'why_visit': 'Swimming with rays',
    'best_time': 'Dec–Apr',
    'language': 'English'
  },
  'Central African Republic': {
    'highlights': ['Bangui', 'Dzanga Sangha'],
    'why_visit': 'Gorillas and forest',
    'best_time': 'Dec–Feb',
    'language': 'French, Sango'
  },
  'Chad': {
    'highlights': [`N'Djamena`, 'Ennedi'],
    'why_visit': 'Desert arches',
    'best_time': 'Nov–Feb',
    'language': 'French, Arabic'
  },
  'Chile': {
    'highlights': ['Santiago', 'Easter Island'],
    'why_visit': 'Atacama and wine',
    'best_time': 'Sep–Nov',
    'language': 'Spanish'
  },
  'China': {
    'highlights': ['Beijing', 'Great Wall'],
    'why_visit': 'Ancient civilization',
    'best_time': 'Apr–Oct',
    'language': 'Mandarin Chinese'
  },
  'Christmas Island': {
    'highlights': ['Flying Fish Cove', 'Red Crabs'],
    'why_visit': 'Crab migration',
    'best_time': 'Oct–Dec',
    'language': 'English (de facto)'
  },
  'Cocos Islands': {
    'highlights': ['West Island', 'Lagoon'],
    'why_visit': 'Remote diving',
    'best_time': 'Apr–Oct',
    'language': 'Malay, English'
  },
  'Colombia': {
    'highlights': ['Bogotá', 'Medellín'],
    'why_visit': 'Coffee and salsa',
    'best_time': 'Dec–Mar',
    'language': 'Spanish'
  },
  'Comoros': {
    'highlights': ['Moroni', 'Mount Karthala'],
    'why_visit': 'Volcanic islands',
    'best_time': 'May–Oct',
    'language': 'Comorian, Arabic, French'
  },
  'Cook Islands': {
    'highlights': ['Avarua', 'Aitutaki'],
    'why_visit': 'Lagoon paradise',
    'best_time': 'May–Oct',
    'language': 'English, Cook Islands Maori'
  },
  'Costa Rica': {
    'highlights': ['San José', 'Arenal'],
    'why_visit': 'Pura vida nature',
    'best_time': 'Dec–Apr',
    'language': 'Spanish'
  },
  'Croatia': {
    'highlights': ['Dubrovnik', 'Plitvice'],
    'why_visit': 'Adriatic gem',
    'best_time': 'May–Sep',
    'language': 'Croatian'
  },
  'Cuba': {
    'highlights': ['Havana', 'Viñales'],
    'why_visit': 'Classic cars and cigars',
    'best_time': 'Nov–Apr',
    'language': 'Spanish'
  },
  'Curacao': {
    'highlights': ['Willemstad', 'Christoffel'],
    'why_visit': 'Colorful Dutch colony',
    'best_time': 'Dec–Apr',
    'language': 'Dutch, Papiamento, English'
  },
  'Cyprus': {
    'highlights': ['Nicosia', `Aphrodite's Rock`],
    'why_visit': 'Mythology and beaches',
    'best_time': 'Mar–May',
    'language': 'Greek, Turkish'
  },
  'Czech Republic': {
    'highlights': ['Prague', 'Český Krumlov'],
    'why_visit': 'Castles and beer',
    'best_time': 'Apr–Oct',
    'language': 'Czech'
  },
  'Democratic Republic of the Congo': {
    'highlights': ['Kinshasa', 'Virunga'],
    'why_visit': 'Mountain gorillas',
    'best_time': 'Jun–Aug',
    'language': 'French'
  },
  'Denmark': {
    'highlights': ['Copenhagen', 'Nyhavn'],
    'why_visit': 'Hygge and design',
    'best_time': 'May–Aug',
    'language': 'Danish'
  },
  'Djibouti': {
    'highlights': ['Djibouti City', 'Lake Assal'],
    'why_visit': 'Salt and whalesharks',
    'best_time': 'Nov–Mar',
    'language': 'Arabic, French'
  },
  'Dominica': {
    'highlights': ['Roseau', 'Boiling Lake'],
    'why_visit': 'Nature island',
    'best_time': 'Dec–Apr',
    'language': 'English'
  },
  'Dominican Republic': {
    'highlights': ['Santo Domingo', 'Punta Cana'],
    'why_visit': 'Resorts and merengue',
    'best_time': 'Dec–Apr',
    'language': 'Spanish'
  },
  'East Timor': {
    'highlights': ['Dili', 'Atauro'],
    'why_visit': 'Diving and mountains',
    'best_time': 'May–Nov',
    'language': 'Portuguese, Tetum'
  },
  'Ecuador': {
    'highlights': ['Quito', 'Galapagos'],
    'why_visit': 'Evolution in action',
    'best_time': 'Jun–Sep',
    'language': 'Spanish'
  },
  'Egypt': {
    'highlights': ['Cairo', 'Pyramids'],
    'why_visit': 'Ancient pharaohs',
    'best_time': 'Oct–Apr',
    'language': 'Arabic'
  },
  'El Salvador': {
    'highlights': ['San Salvador', 'Ruta de las Flores'],
    'why_visit': 'Volcano surfing',
    'best_time': 'Nov–Apr',
    'language': 'Spanish'
  },
  'Equatorial Guinea': {
    'highlights': ['Malabo', 'Bioko'],
    'why_visit': 'Spanish African gem',
    'best_time': 'Dec–Feb',
    'language': 'Spanish, French, Portuguese'
  },
  'Eritrea': {
    'highlights': ['Asmara', 'Massawa'],
    'why_visit': 'Italian art deco',
    'best_time': 'Oct–Apr',
    'language': 'Tigrinya, Arabic, English'
  },
  'Estonia': {
    'highlights': ['Tallinn', 'Lahemaa'],
    'why_visit': 'Medieval old town',
    'best_time': 'May–Sep',
    'language': 'Estonian'
  },
  'Eswatini': {
    'highlights': ['Mbabane', 'Hlane Park'],
    'why_visit': 'Swazi culture',
    'best_time': 'May–Aug',
    'language': 'English, Swazi'
  },
  'Ethiopia': {
    'highlights': ['Addis Ababa', 'Lalibela'],
    'why_visit': 'Rock churches',
    'best_time': 'Oct–Jun',
    'language': 'Amharic, Oromo, Tigrinya, Somali, Afar'
  },
  'Falkland Islands': {
    'highlights': ['Stanley', 'Penguins'],
    'why_visit': 'Wildlife colonies',
    'best_time': 'Nov–Mar',
    'language': 'English'
  },
  'Faroe Islands': {
    'highlights': ['Tórshavn', 'Mykines'],
    'why_visit': 'Dramatic cliffs',
    'best_time': 'Jun–Aug',
    'language': 'Faroese, Danish'
  },
  'Fiji': {
    'highlights': ['Suva', 'Yasawas'],
    'why_visit': 'Smiling locals',
    'best_time': 'May–Oct',
    'language': 'English, Fijian, Fiji Hindi'
  },
  'Finland': {
    'highlights': ['Helsinki', 'Lapland'],
    'why_visit': 'Northern lights',
    'best_time': 'Dec–Mar',
    'language': 'Finnish, Swedish'
  },
  'France': {
    'highlights': ['Paris', 'Provence'],
    'why_visit': 'Art and cuisine',
    'best_time': 'Apr–Oct',
    'language': 'French'
  },
  'French Guiana': {
    'highlights': ['Cayenne', `Devil's Island`],
    'why_visit': 'Spaceport and jungle',
    'best_time': 'Aug–Nov',
    'language': 'French'
  },
  'French Polynesia': {
    'highlights': ['Papeete', 'Bora Bora'],
    'why_visit': 'Overwater bungalows',
    'best_time': 'May–Oct',
    'language': 'French'
  },
  'French Southern Territories': {
    'highlights': ['Kerguelen', 'Crozet'],
    'why_visit': 'Remote wilderness',
    'best_time': 'Dec–Feb',
    'language': 'French'
  },
  'Gabon': {
    'highlights': ['Libreville', 'Loango'],
    'why_visit': 'Surfing hippos',
    'best_time': 'Jun–Aug',
    'language': 'French'
  },
  'Gambia': {
    'highlights': ['Banjul', 'Serrekunda'],
    'why_visit': 'River wildlife',
    'best_time': 'Nov–May',
    'language': 'English'
  },
  'Georgia': {
    'highlights': ['Tbilisi', 'Kazbegi'],
    'why_visit': 'Wine and mountains',
    'best_time': 'May–Oct',
    'language': 'Georgian'
  },
  'Germany': {
    'highlights': ['Berlin', 'Bavaria'],
    'why_visit': 'Castles and beer',
    'best_time': 'May–Sep',
    'language': 'German'
  },
  'Ghana': {
    'highlights': ['Accra', 'Cape Coast'],
    'why_visit': 'Castles and cocoa',
    'best_time': 'Oct–Mar',
    'language': 'English'
  },
  'Gibraltar': {
    'highlights': ['Rock', 'Barbary macaques'],
    'why_visit': 'UK in the sun',
    'best_time': 'Apr–Oct',
    'language': 'English'
  },
  'Greece': {
    'highlights': ['Athens', 'Santorini'],
    'why_visit': 'Islands and history',
    'best_time': 'May–Sep',
    'language': 'Greek'
  },
  'Greenland': {
    'highlights': ['Nuuk', 'Ilulissat'],
    'why_visit': 'Massive icebergs',
    'best_time': 'Jun–Aug',
    'language': 'Greenlandic, Danish'
  },
  'Grenada': {
    'highlights': [`St George's`, 'Spice Island'],
    'why_visit': 'Nutmeg and beaches',
    'best_time': 'January–May',
    'language': 'English'
  },
  'Guadeloupe': {
    'highlights': ['Basse-Terre', 'Grande-Terre'],
    'why_visit': 'Butterfly island',
    'best_time': 'Dec–Apr',
    'language': 'French'
  },
  'Guam': {
    'highlights': ['Hagåtña', 'Tumon'],
    'why_visit': 'Chamorro culture',
    'best_time': 'January–Jun',
    'language': 'English, Chamorro'
  },
  'Guatemala': {
    'highlights': ['Antigua', 'Tikal'],
    'why_visit': 'Mayan pyramids',
    'best_time': 'Nov–Apr',
    'language': 'Spanish'
  },
  'Guernsey': {
    'highlights': ['St Peter Port', 'Victor Hugo'],
    'why_visit': 'Channel charm',
    'best_time': 'May–Sep',
    'language': 'English, French'
  },
  'Guinea': {
    'highlights': ['Conakry', 'Fouta Djallon'],
    'why_visit': 'Waterfalls and hills',
    'best_time': 'Nov–Mar',
    'language': 'French'
  },
  'Guinea-Bissau': {
    'highlights': ['Bissau', 'Bijagós'],
    'why_visit': 'Untouched islands',
    'best_time': 'Nov–Apr',
    'language': 'Portuguese'
  },
  'Guyana': {
    'highlights': ['Georgetown', 'Kaieteur'],
    'why_visit': 'Massive waterfall',
    'best_time': 'Feb–Apr',
    'language': 'English'
  },
  'Haiti': {
    'highlights': ['Port-au-Prince', 'Citadelle'],
    'why_visit': 'Fortress history',
    'best_time': 'Nov–Mar',
    'language': 'French, Haitian Creole'
  },
  'Heard Island and McDonald Islands': {
    'highlights': ['Big Ben', 'Glaciers'],
    'why_visit': 'Active volcano',
    'best_time': 'Dec–Feb',
    'language': 'No official language'
  },
  'Honduras': {
    'highlights': ['Tegucigalpa', 'Roatán'],
    'why_visit': 'Coral reefs',
    'best_time': 'Dec–Apr',
    'language': 'Spanish'
  },
  'Hong Kong': {
    'highlights': ['Victoria Harbour', 'Tsim Sha Tsui'],
    'why_visit': 'Skyline and dim sum',
    'best_time': 'Oct–Dec',
    'language': 'Chinese, English'
  },
  'Hungary': {
    'highlights': ['Budapest', 'Danube'],
    'why_visit': 'Thermal baths',
    'best_time': 'Apr–Oct',
    'language': 'Hungarian'
  },
  'Iceland': {
    'highlights': ['Reykjavík', 'Blue Lagoon'],
    'why_visit': 'Fire and ice',
    'best_time': 'Jun–Aug',
    'language': 'Icelandic'
  },
  'India': {
    'highlights': ['Delhi', 'Taj Mahal'],
    'why_visit': 'Colors and spices',
    'best_time': 'Oct–Mar',
    'language': 'Hindi, English (and 22 scheduled languages)'
  },
  'Indonesia': {
    'highlights': ['Bali', 'Jakarta'],
    'why_visit': 'Volcanoes and temples',
    'best_time': 'Apr–Oct',
    'language': 'Indonesian'
  },
  'Iran': {
    'highlights': ['Isfahan', 'Persepolis'],
    'why_visit': 'Persian heritage',
    'best_time': 'Mar–May',
    'language': 'Persian (Farsi)'
  },
  'Iraq': {
    'highlights': ['Baghdad', 'Babylon'],
    'why_visit': 'Cradle of civilization',
    'best_time': 'Oct–Apr',
    'language': 'Arabic, Kurdish'
  },
  'Ireland': {
    'highlights': ['Dublin', 'Cliffs of Moher'],
    'why_visit': 'Green landscapes',
    'best_time': 'Jun–Aug',
    'language': 'Irish, English'
  },
  'Isle of Man': {
    'highlights': ['Douglas', 'TT Circuit'],
    'why_visit': 'Motorcycle racing',
    'best_time': 'May–Sep',
    'language': 'English, Manx'
  },
  'Israel': {
    'highlights': ['Jerusalem', 'Tel Aviv'],
    'why_visit': 'Holy land',
    'best_time': 'Mar–May',
    'language': 'Hebrew, Arabic'
  },
  'Italy': {
    'highlights': ['Rome', 'Venice'],
    'why_visit': 'Pasta and art',
    'best_time': 'Apr–Jun',
    'language': 'Italian'
  },
  'Ivory Coast': {
    'highlights': ['Yamoussoukro', 'Grand-Bassam'],
    'why_visit': 'Colonial beaches',
    'best_time': 'Nov–Mar',
    'language': 'French'
  },
  'Jamaica': {
    'highlights': ['Kingston', 'Negril'],
    'why_visit': 'Reggae and jerk',
    'best_time': 'Nov–Dec',
    'language': 'English'
  },
  'Japan': {
    'highlights': ['Tokyo', 'Kyoto'],
    'why_visit': 'Cherry blossoms',
    'best_time': 'Mar–May',
    'language': 'Japanese'
  },
  'Jersey': {
    'highlights': ['St Helier', 'Jersey War Tunnels'],
    'why_visit': 'Channel Island',
    'best_time': 'May–Sep',
    'language': 'English, French, Jèrriais'
  },
  'Jordan': {
    'highlights': ['Amman', 'Petra'],
    'why_visit': 'Rose red city',
    'best_time': 'Mar–May',
    'language': 'Arabic'
  },
  'Kazakhstan': {
    'highlights': ['Nur-Sultan', 'Almaty'],
    'why_visit': 'Steppe and futuristic',
    'best_time': 'Apr–Oct',
    'language': 'Kazakh, Russian'
  },
  'Kenya': {
    'highlights': ['Nairobi', 'Maasai Mara'],
    'why_visit': 'Great migration',
    'best_time': 'Jul–Oct',
    'language': 'English, Swahili'
  },
  'Kiribati': {
    'highlights': ['Tarawa', 'Christmas Island'],
    'why_visit': 'First sunrise',
    'best_time': 'May–Oct',
    'language': 'English, Gilbertese'
  },
  'Kosovo': {
    'highlights': ['Pristina', 'Prizren'],
    'why_visit': 'Young nation',
    'best_time': 'May–Sep',
    'language': 'Albanian, Serbian'
  },
  'Kuwait': {
    'highlights': ['Kuwait City', 'Towers'],
    'why_visit': 'Modern Arabian',
    'best_time': 'Nov–Apr',
    'language': 'Arabic'
  },
  'Kyrgyzstan': {
    'highlights': ['Bishkek', 'Issyk-Kul'],
    'why_visit': 'Alpine lakes',
    'best_time': 'Jun–Sep',
    'language': 'Kyrgyz, Russian'
  },
  'Laos': {
    'highlights': ['Luang Prabang', 'Vientiane'],
    'why_visit': 'Mekong serenity',
    'best_time': 'Nov–Mar',
    'language': 'Lao'
  },
  'Latvia': {
    'highlights': ['Riga', 'Jurmala'],
    'why_visit': 'Art nouveau',
    'best_time': 'May–Sep',
    'language': 'Latvian'
  },
  'Lebanon': {
    'highlights': ['Beirut', 'Byblos'],
    'why_visit': 'Phoenician roots',
    'best_time': 'Apr–Jun',
    'language': 'Arabic, French'
  },
  'Lesotho': {
    'highlights': ['Maseru', 'Maletsunyane'],
    'why_visit': 'Kingdom in the sky',
    'best_time': 'May–Sep',
    'language': 'English, Sesotho'
  },
  'Liberia': {
    'highlights': ['Monrovia', 'Sapo Park'],
    'why_visit': 'Rainforests',
    'best_time': 'Nov–Apr',
    'language': 'English'
  },
  'Libya': {
    'highlights': ['Tripoli', 'Leptis Magna'],
    'why_visit': 'Roman ruins',
    'best_time': 'Mar–May',
    'language': 'Arabic'
  },
  'Liechtenstein': {
    'highlights': ['Vaduz', 'Castle'],
    'why_visit': 'Alpine principality',
    'best_time': 'May–Sep',
    'language': 'German'
  },
  'Lithuania': {
    'highlights': ['Vilnius', 'Trakai'],
    'why_visit': 'Baroque beauty',
    'best_time': 'May–Sep',
    'language': 'Lithuanian'
  },
  'Luxembourg': {
    'highlights': ['Luxembourg City', 'Müllerthal'],
    'why_visit': 'Little Switzerland',
    'best_time': 'May–Oct',
    'language': 'Luxembourgish, French, German'
  },
  'Macao': {
    'highlights': [`Ruins of St Paul's`, 'Casinos'],
    'why_visit': 'Las Vegas of Asia',
    'best_time': 'Oct–Dec',
    'language': 'Chinese, Portuguese'
  },
  'Macedonia': {
    'highlights': ['Skopje', 'Ohrid'],
    'why_visit': 'Ancient lake',
    'best_time': 'May–Sep',
    'language': 'Macedonian, Albanian'
  },
  'Madagascar': {
    'highlights': ['Antananarivo', 'Avenue of Baobabs'],
    'why_visit': 'Lemurs and baobabs',
    'best_time': 'Apr–Oct',
    'language': 'Malagasy, French'
  },
  'Malawi': {
    'highlights': ['Lilongwe', 'Lake Malawi'],
    'why_visit': 'Lake of stars',
    'best_time': 'May–Oct',
    'language': 'English, Chichewa'
  },
  'Malaysia': {
    'highlights': ['Kuala Lumpur', 'Penang'],
    'why_visit': 'Street food paradise',
    'best_time': 'Dec–Feb',
    'language': 'Malay'
  },
  'Maldives': {
    'highlights': ['Malé', 'Luxury resorts'],
    'why_visit': 'Overwater villas',
    'best_time': 'Nov–Apr',
    'language': 'Dhivehi'
  },
  'Mali': {
    'highlights': ['Bamako', 'Timbuktu'],
    'why_visit': 'Mud mosques',
    'best_time': 'Nov–Feb',
    'language': 'French'
  },
  'Malta': {
    'highlights': ['Valletta', 'Mdina'],
    'why_visit': 'Knights and cliffs',
    'best_time': 'Apr–Oct',
    'language': 'Maltese, English'
  },
  'Marshall Islands': {
    'highlights': ['Majuro', 'Bikini Atoll'],
    'why_visit': 'Nuclear history',
    'best_time': 'Dec–Apr',
    'language': 'Marshallese, English'
  },
  'Martinique': {
    'highlights': ['Fort-de-France', 'Mount Pelée'],
    'why_visit': 'French Caribbean',
    'best_time': 'Dec–Apr',
    'language': 'French'
  },
  'Mauritania': {
    'highlights': ['Nouakchott', 'Chinguetti'],
    'why_visit': 'Desert libraries',
    'best_time': 'Nov–Mar',
    'language': 'Arabic'
  },
  'Mauritius': {
    'highlights': ['Port Louis', 'Seven Coloured Earths'],
    'why_visit': 'Dodo island',
    'best_time': 'May–Dec',
    'language': 'English, French, Mauritian Creole'
  },
  'Mayotte': {
    'highlights': ['Mamoudzou', 'Lagoon'],
    'why_visit': 'Marine reserve',
    'best_time': 'Apr–Nov',
    'language': 'French'
  },
  'Mexico': {
    'highlights': ['Mexico City', 'Cancún'],
    'why_visit': 'Tequila and tacos',
    'best_time': 'Nov–Apr',
    'language': 'Spanish'
  },
  'Micronesia': {
    'highlights': ['Palikir', 'Nan Madol'],
    'why_visit': 'Venice of the Pacific',
    'best_time': 'Dec–Mar',
    'language': 'English'
  },
  'Moldova': {
    'highlights': ['Chișinău', 'Cricova'],
    'why_visit': 'Underground wine',
    'best_time': 'May–Sep',
    'language': 'Romanian'
  },
  'Monaco': {
    'highlights': ['Monte Carlo', 'Casino'],
    'why_visit': 'Glitz and F1',
    'best_time': 'Apr–Oct',
    'language': 'French'
  },
  'Mongolia': {
    'highlights': ['Ulaanbaatar', 'Gobi Desert'],
    'why_visit': 'Nomadic steppe',
    'best_time': 'Jun–Aug',
    'language': 'Mongolian'
  },
  'Montenegro': {
    'highlights': ['Kotor', 'Budva'],
    'why_visit': 'Bay of Kotor',
    'best_time': 'May–Sep',
    'language': 'Montenegrin'
  },
  'Montserrat': {
    'highlights': ['Plymouth', 'Soufrière Hills'],
    'why_visit': 'Volcano buried city',
    'best_time': 'Dec–Apr',
    'language': 'English'
  },
  'Morocco': {
    'highlights': ['Marrakech', 'Sahara'],
    'why_visit': 'Souks and mint tea',
    'best_time': 'Mar–May',
    'language': 'Arabic, Tamazight'
  },
  'Mozambique': {
    'highlights': ['Maputo', 'Bazaruto'],
    'why_visit': 'Ocean paradise',
    'best_time': 'May–Nov',
    'language': 'Portuguese'
  },
  'Myanmar': {
    'highlights': ['Bagan', 'Yangon'],
    'why_visit': 'Thousands of pagodas',
    'best_time': 'Nov–Feb',
    'language': 'Burmese'
  },
  'Namibia': {
    'highlights': ['Windhoek', 'Sossusvlei'],
    'why_visit': 'Red dunes',
    'best_time': 'May–Oct',
    'language': 'English'
  },
  'Nauru': {
    'highlights': ['Yaren', 'Phosphate'],
    'why_visit': `World's smallest island`,
    'best_time': 'May–Oct',
    'language': 'Nauruan, English'
  },
  'Nepal': {
    'highlights': ['Kathmandu', 'Everest'],
    'why_visit': 'Himalayan trekking',
    'best_time': 'Oct–Nov',
    'language': 'Nepali'
  },
  'Netherlands': {
    'highlights': ['Amsterdam', 'Keukenhof'],
    'why_visit': 'Tulips and canals',
    'best_time': 'Apr–Sep',
    'language': 'Dutch'
  },
  'New Caledonia': {
    'highlights': ['Nouméa', 'Lagoons'],
    'why_visit': 'French Pacific',
    'best_time': 'Sep–Nov',
    'language': 'French'
  },
  'New Zealand': {
    'highlights': ['Queenstown', 'Rotorua'],
    'why_visit': 'Adventure capital',
    'best_time': 'Dec–Feb',
    'language': 'English, Maori, NZ Sign Language'
  },
  'Nicaragua': {
    'highlights': ['Managua', 'Granada'],
    'why_visit': 'Lakes and volcanoes',
    'best_time': 'Nov–Apr',
    'language': 'Spanish'
  },
  'Niger': {
    'highlights': ['Niamey', 'Agadez'],
    'why_visit': 'Desert trading post',
    'best_time': 'Nov–Feb',
    'language': 'French'
  },
  'Nigeria': {
    'highlights': ['Lagos', 'Abuja'],
    'why_visit': 'Afrobeats energy',
    'best_time': 'Nov–January',
    'language': 'English'
  },
  'Niue': {
    'highlights': ['Alofi', 'Limestone caves'],
    'why_visit': 'Rock of Polynesia',
    'best_time': 'May–Oct',
    'language': 'Niuean, English'
  },
  'Norfolk Island': {
    'highlights': ['Kingston', 'Pine trees'],
    'why_visit': 'Pitcairn history',
    'best_time': 'Sep–Mar',
    'language': 'English, Norfuk'
  },
  'North Korea': {
    'highlights': ['Pyongyang', 'DMZ'],
    'why_visit': 'Most secretive state',
    'best_time': 'Apr–Oct',
    'language': 'Korean'
  },
  'Northern Mariana Islands': {
    'highlights': ['Saipan', 'Grotto'],
    'why_visit': 'WWII history',
    'best_time': 'Dec–Jun',
    'language': 'English, Chamorro, Carolinian'
  },
  'Norway': {
    'highlights': ['Oslo', 'Fjords'],
    'why_visit': 'Midnight sun',
    'best_time': 'May–Aug',
    'language': 'Norwegian, Sami'
  },
  'Oman': {
    'highlights': ['Muscat', 'Wahiba Sands'],
    'why_visit': 'Frankincense land',
    'best_time': 'Oct–Apr',
    'language': 'Arabic'
  },
  'Pakistan': {
    'highlights': ['Islamabad', 'Hunza'],
    'why_visit': 'Mountain valleys',
    'best_time': 'Apr–Oct',
    'language': 'Urdu, English'
  },
  'Palau': {
    'highlights': ['Ngerulmud', 'Jellyfish Lake'],
    'why_visit': 'Jellyfish paradise',
    'best_time': 'Nov–Apr',
    'language': 'Palauan, English'
  },
  'Palestinian Territory': {
    'highlights': ['Ramallah', 'Bethlehem'],
    'why_visit': 'Biblical birthplace',
    'best_time': 'Mar–May',
    'language': 'Arabic'
  },
  'Panama': {
    'highlights': ['Panama City', 'Canal'],
    'why_visit': 'Engineering marvel',
    'best_time': 'Dec–Apr',
    'language': 'Spanish'
  },
  'Papua New Guinea': {
    'highlights': ['Port Moresby', 'Kokoda'],
    'why_visit': 'Tribal culture',
    'best_time': 'May–Oct',
    'language': 'English, Tok Pisin, Hiri Motu'
  },
  'Paraguay': {
    'highlights': ['Asunción', 'Jesuit Ruins'],
    'why_visit': 'Heart of South America',
    'best_time': 'Apr–Sep',
    'language': 'Spanish, Guarani'
  },
  'Peru': {
    'highlights': ['Lima', 'Machu Picchu'],
    'why_visit': 'Inca citadel',
    'best_time': 'May–Sep',
    'language': 'Spanish'
  },
  'Philippines': {
    'highlights': ['Manila', 'Palawan'],
    'why_visit': 'Tropical islands',
    'best_time': 'Dec–May',
    'language': 'Filipino, English'
  },
  'Pitcairn': {
    'highlights': ['Adamstown', 'Bounty Bay'],
    'why_visit': 'Mutineer haven',
    'best_time': 'January–Mar',
    'language': 'English, Pitkern'
  },
  'Poland': {
    'highlights': ['Kraków', 'Warsaw'],
    'why_visit': 'Pierogi and castles',
    'best_time': 'May–Sep',
    'language': 'Polish'
  },
  'Portugal': {
    'highlights': ['Lisbon', 'Algarve'],
    'why_visit': 'Pastel de nata',
    'best_time': 'Mar–Oct',
    'language': 'Portuguese'
  },
  'Puerto Rico': {
    'highlights': ['San Juan', 'El Yunque'],
    'why_visit': 'Rainforest and rum',
    'best_time': 'Dec–Apr',
    'language': 'Spanish, English'
  },
  'Qatar': {
    'highlights': ['Doha', 'Souq Waqif'],
    'why_visit': 'Desert modernism',
    'best_time': 'Nov–Mar',
    'language': 'Arabic'
  },
  'Republic of the Congo': {
    'highlights': ['Brazzaville', 'Odzala'],
    'why_visit': 'Gorilla trekking',
    'best_time': 'Jun–Aug',
    'language': 'French'
  },
  'Reunion': {
    'highlights': ['Saint-Denis', 'Piton de la Fournaise'],
    'why_visit': 'Active volcano',
    'best_time': 'May–Nov',
    'language': 'French'
  },
  'Romania': {
    'highlights': ['Bucharest', 'Transylvania'],
    'why_visit': `Dracula's castle`,
    'best_time': 'May–Sep',
    'language': 'Romanian'
  },
  'Russia': {
    'highlights': ['Moscow', 'St Petersburg'],
    'why_visit': 'Red Square and ballet',
    'best_time': 'May–Sep',
    'language': 'Russian'
  },
  'Rwanda': {
    'highlights': ['Kigali', 'Volcanoes Park'],
    'why_visit': 'Gorillas in the mist',
    'best_time': 'Jun–Sep',
    'language': 'Kinyarwanda, English, French, Swahili'
  },
  'Saint Barthelemy': {
    'highlights': ['Gustavia', 'Shell Beach'],
    'why_visit': 'Jet-set island',
    'best_time': 'Dec–Apr',
    'language': 'French'
  },
  'Saint Helena': {
    'highlights': ['Jamestown', `Napoleon's Tomb`],
    'why_visit': 'Remote exile',
    'best_time': 'Dec–Apr',
    'language': 'English'
  },
  'Saint Kitts and Nevis': {
    'highlights': ['Basseterre', 'Brimstone Hill'],
    'why_visit': 'Fortress and beaches',
    'best_time': 'Dec–Apr',
    'language': 'English'
  },
  'Saint Lucia': {
    'highlights': ['Castries', 'Pitons'],
    'why_visit': 'Volcanic peaks',
    'best_time': 'Dec–Apr',
    'language': 'English'
  },
  'Saint Martin': {
    'highlights': ['Philipsburg', 'Mahó Beach'],
    'why_visit': 'Planes landing overhead',
    'best_time': 'Dec–Apr',
    'language': 'French, English, Dutch'
  },
  'Saint Pierre and Miquelon': {
    'highlights': ['Saint-Pierre', 'Grande Miquelon'],
    'why_visit': 'French in North America',
    'best_time': 'Jun–Sep',
    'language': 'French'
  },
  'Saint Vincent and the Grenadines': {
    'highlights': ['Kingstown', 'Bequia'],
    'why_visit': 'Yacht paradise',
    'best_time': 'Dec–Apr',
    'language': 'English'
  },
  'Samoa': {
    'highlights': ['Apia', 'To Sua Trench'],
    'why_visit': 'Swimming hole',
    'best_time': 'May–Oct',
    'language': 'Samoan, English'
  },
  'San Marino': {
    'highlights': ['San Marino City', 'Three Towers'],
    'why_visit': 'Oldest republic',
    'best_time': 'Apr–Oct',
    'language': 'Italian'
  },
  'Sao Tome and Principe': {
    'highlights': ['São Tomé', 'Rolas'],
    'why_visit': 'Equator cocoa',
    'best_time': 'Jun–Sep',
    'language': 'Portuguese'
  },
  'Saudi Arabia': {
    'highlights': ['Riyadh', 'AlUla'],
    'why_visit': 'Ancient Nabatean tombs',
    'best_time': 'Nov–Mar',
    'language': 'Arabic'
  },
  'Senegal': {
    'highlights': ['Dakar', 'Gorée Island'],
    'why_visit': 'Door of no return',
    'best_time': 'Nov–May',
    'language': 'French'
  },
  'Serbia': {
    'highlights': ['Belgrade', 'Novi Sad'],
    'why_visit': 'Rakija and nightlife',
    'best_time': 'Apr–Oct',
    'language': 'Serbian'
  },
  'Seychelles': {
    'highlights': ['Victoria', 'Praslin'],
    'why_visit': 'Giant tortoises',
    'best_time': 'Apr–Oct',
    'language': 'Seychellois Creole, English, French'
  },
  'Sierra Leone': {
    'highlights': ['Freetown', 'Tacugama'],
    'why_visit': 'Chimpanzee sanctuary',
    'best_time': 'Nov–Apr',
    'language': 'English'
  },
  'Singapore': {
    'highlights': ['Marina Bay', 'Sentosa'],
    'why_visit': 'Garden city',
    'best_time': 'Feb–Apr',
    'language': 'English, Chinese, Malay, Tamil'
  },
  'Sint Maarten': {
    'highlights': ['Philipsburg', 'Mahó Beach'],
    'why_visit': 'Low flying planes',
    'best_time': 'Dec–Apr',
    'language': 'Dutch, English'
  },
  'Slovakia': {
    'highlights': ['Bratislava', 'High Tatras'],
    'why_visit': 'Castle ruins',
    'best_time': 'May–Sep',
    'language': 'Slovak'
  },
  'Slovenia': {
    'highlights': ['Ljubljana', 'Lake Bled'],
    'why_visit': 'Church on island',
    'best_time': 'May–Sep',
    'language': 'Slovene'
  },
  'Solomon Islands': {
    'highlights': ['Honiara', 'WWII wrecks'],
    'why_visit': 'Diving history',
    'best_time': 'Apr–Nov',
    'language': 'English'
  },
  'Somalia': {
    'highlights': ['Mogadishu', 'Laas Geel'],
    'why_visit': 'Ancient cave art',
    'best_time': 'Jul–Sep',
    'language': 'Somali, Arabic'
  },
  'South Africa': {
    'highlights': ['Cape Town', 'Kruger'],
    'why_visit': 'Big Five safari, Wine',
    'best_time': 'May–Sep',
    'language': 'Afrikaans, English, Zulu, Xhosa, and 7 others'
  },
  'South Georgia and the South Sandwich Islands': {
    'highlights': ['Grytviken', 'King penguins'],
    'why_visit': `Shackleton's grave`,
    'best_time': 'Nov–Mar',
    'language': 'English'
  },
  'South Korea': {
    'highlights': ['Seoul', 'Busan'],
    'why_visit': 'K-pop and kimchi',
    'best_time': 'Mar–May',
    'language': 'Korean'
  },
  'South Sudan': {
    'highlights': ['Juba', 'Boma Park'],
    'why_visit': `World's youngest nation`,
    'best_time': 'Dec–Feb',
    'language': 'English'
  },
  'Spain': {
    'highlights': ['Barcelona', 'Madrid'],
    'why_visit': 'Tapas and siesta',
    'best_time': 'Apr–Oct',
    'language': 'Spanish'
  },
  'Sri Lanka': {
    'highlights': ['Colombo', 'Sigiriya'],
    'why_visit': 'Lion rock fortress',
    'best_time': 'Dec–Mar',
    'language': 'Sinhala, Tamil'
  },
  'Sudan': {
    'highlights': ['Khartoum', 'Meroë'],
    'why_visit': 'Pyramids of Nubia',
    'best_time': 'Nov–Feb',
    'language': 'Arabic, English'
  },
  'Suriname': {
    'highlights': ['Paramaribo', 'Central Park'],
    'why_visit': 'Dutch wooden city',
    'best_time': 'Feb–Aug',
    'language': 'Dutch'
  },
  'Svalbard and Jan Mayen': {
    'highlights': ['Longyearbyen', 'Polar bears'],
    'why_visit': 'Arctic wilderness',
    'best_time': 'Apr–Aug',
    'language': 'Norwegian'
  },
  'Sweden': {
    'highlights': ['Stockholm', 'Gothenburg'],
    'why_visit': 'Fika and forests',
    'best_time': 'May–Aug',
    'language': 'Swedish'
  },
  'Switzerland': {
    'highlights': ['Zurich', 'Alps'],
    'why_visit': 'Chocolate and watches',
    'best_time': 'Jun–Sep',
    'language': 'German, French, Italian, Romansh'
  },
  'Syria': {
    'highlights': ['Damascus', 'Palmyra'],
    'why_visit': 'Ancient crossroads',
    'best_time': 'Mar–May',
    'language': 'Arabic'
  },
  'Taiwan': {
    'highlights': ['Taipei', 'Taroko'],
    'why_visit': 'Night markets',
    'best_time': 'Oct–Dec',
    'language': 'Chinese (Mandarin)'
  },
  'Tajikistan': {
    'highlights': ['Dushanbe', 'Pamir Highway'],
    'why_visit': 'Roof of the world',
    'best_time': 'Jun–Sep',
    'language': 'Tajik, Russian'
  },
  'Tanzania': {
    'highlights': ['Dodoma', 'Serengeti'],
    'why_visit': 'Kilimanjaro and Zanzibar',
    'best_time': 'Jun–Oct',
    'language': 'Swahili, English'
  },
  'Thailand': {
    'highlights': ['Bangkok', 'Phuket'],
    'why_visit': 'Mango sticky rice',
    'best_time': 'Nov–Feb',
    'language': 'Thai'
  },
  'Togo': {
    'highlights': ['Lomé', 'Koutammakou'],
    'why_visit': 'Mud tower houses',
    'best_time': 'Nov–Feb',
    'language': 'French'
  },
  'Tokelau': {
    'highlights': ['Atafu', 'Canoes'],
    'why_visit': 'No cars, no stress',
    'best_time': 'Apr–Oct',
    'language': 'Tokelauan, English'
  },
  'Tonga': {
    'highlights': ['Nukuʻalofa', 'Haʻapai'],
    'why_visit': 'Whale swimming',
    'best_time': 'Jul–Oct',
    'language': 'Tongan, English'
  },
  'Trinidad and Tobago': {
    'highlights': ['Port of Spain', 'Carnival'],
    'why_visit': 'Steelpan music',
    'best_time': 'January–Mar',
    'language': 'English'
  },
  'Tunisia': {
    'highlights': ['Tunis', 'Carthage'],
    'why_visit': 'Star Wars sets',
    'best_time': 'Mar–Jun',
    'language': 'Arabic'
  },
  'Turkey': {
    'highlights': ['Istanbul', 'Cappadocia'],
    'why_visit': 'Hot air balloons',
    'best_time': 'Apr–Oct',
    'language': 'Turkish'
  },
  'Turkmenistan': {
    'highlights': ['Ashgabat', 'Door to Hell'],
    'why_visit': 'Burning gas crater',
    'best_time': 'Apr–Jun',
    'language': 'Turkmen'
  },
  'Turks and Caicos Islands': {
    'highlights': ['Cockburn Town', 'Grace Bay'],
    'why_visit': 'Powder sand beaches',
    'best_time': 'Dec–Apr',
    'language': 'English'
  },
  'Tuvalu': {
    'highlights': ['Funafuti', 'Lagoon'],
    'why_visit': 'Sinking paradise',
    'best_time': 'Mar–Oct',
    'language': 'Tuvaluan, English'
  },
  'U.S. Virgin Islands': {
    'highlights': ['Charlotte Amalie', 'Trunk Bay'],
    'why_visit': 'Duty free shopping',
    'best_time': 'Dec–Apr',
    'language': 'English'
  },
  'Uganda': {
    'highlights': ['Kampala', 'Bwindi'],
    'why_visit': 'Mountain gorillas',
    'best_time': 'Jun–Sep',
    'language': 'English, Swahili'
  },
  'Ukraine': {
    'highlights': ['Kyiv', 'Lviv'],
    'why_visit': 'Golden domes',
    'best_time': 'May–Sep',
    'language': 'Ukrainian'
  },
  'United Arab Emirates': {
    'highlights': ['Dubai', 'Abu Dhabi'],
    'why_visit': 'Burj Khalifa',
    'best_time': 'Nov–Mar',
    'language': 'Arabic'
  },
  'United Kingdom': {
    'highlights': ['London', 'Edinburgh'],
    'why_visit': 'Royal history',
    'best_time': 'May–Sep',
    'language': 'English'
  },
  'United States': {
    'highlights': ['New York', 'Grand Canyon'],
    'why_visit': 'Diverse landscapes',
    'best_time': 'Apr–Oct',
    'language': 'English (de facto)'
  },
  'United States Minor Outlying Islands': {
    'highlights': ['Midway', 'Wake Island'],
    'why_visit': 'Remote military bases',
    'best_time': 'January–Mar',
    'language': 'English'
  },
  'Uruguay': {
    'highlights': ['Montevideo', 'Punta del Este'],
    'why_visit': 'Beach resorts',
    'best_time': 'Dec–Mar',
    'language': 'Spanish'
  },
  'Uzbekistan': {
    'highlights': ['Samarkand', 'Bukhara'],
    'why_visit': 'Silk Road blue domes',
    'best_time': 'Apr–Jun',
    'language': 'Uzbek'
  },
  'Vanuatu': {
    'highlights': ['Port Vila', 'Mount Yasur'],
    'why_visit': 'Active volcano',
    'best_time': 'Apr–Oct',
    'language': 'Bislama, English, French'
  },
  'Vatican': {
    'highlights': [`St Peter's`, 'Sistine Chapel'],
    'why_visit': `Michelangelo's ceiling`,
    'best_time': 'Apr–Oct',
    'language': 'Latin, Italian'
  },
  'Venezuela': {
    'highlights': ['Caracas', 'Angel Falls'],
    'why_visit': `World's tallest waterfall`,
    'best_time': 'Dec–Apr',
    'language': 'Spanish'
  },
  'Vietnam': {
    'highlights': ['Hanoi', 'Ha Long Bay'],
    'why_visit': 'Pho and limestone',
    'best_time': 'Nov–Apr',
    'language': 'Vietnamese'
  },
  'Wallis and Futuna': {
    'highlights': ['Mata-Utu', 'Lakes'],
    'why_visit': 'Polynesian kingdom',
    'best_time': 'May–Oct',
    'language': 'French'
  },
  'Western Sahara': {
    'highlights': ['Laayoune', 'Desert'],
    'why_visit': 'Mining and sand',
    'best_time': 'Nov–Mar',
    'language': 'Arabic, Spanish (de facto)'
  },
  'Yemen': {
    'highlights': [`Sana'a`, 'Socotra'],
    'why_visit': 'Dragon blood trees',
    'best_time': 'Oct–Apr',
    'language': 'Arabic'
  },
  'Zambia': {
    'highlights': ['Lusaka', 'Victoria Falls'],
    'why_visit': 'Mosi-oa-Tunya',
    'best_time': 'Jul–Oct',
    'language': 'English'
  },
  'Zimbabwe': {
    'highlights': ['Harare', 'Great Zimbabwe'],
    'why_visit': 'Ancient stone city',
    'best_time': 'Apr–Oct',
    'language': 'English, Shona, Ndebele'
  }
};